import React from "react";
import {
  AppModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "../../components/Common/AppOverlay";

const value = (input) =>
  input === null ||
  input === undefined ||
  String(input).trim() === "" ||
  input === "-"
    ? "Not recorded"
    : String(input);
const timestamp = (input) => {
  if (!input) return "Not recorded";
  // SQL-backed account timestamps arrive without an offset; interpret them as UTC,
  // consistently with the security-history API, before formatting for the browser.
  const normalized =
    typeof input === "string" &&
    /^\d{4}-\d{2}-\d{2}T/.test(input) &&
    !/(Z|[+-]\d{2}:?\d{2})$/i.test(input)
      ? `${input}Z`
      : input;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? "Not recorded" : date.toLocaleString();
};
const flag = (input, yes, no) =>
  input === 1 || input === "1"
    ? yes
    : input === 0 || input === "0"
    ? no
    : "Not recorded";

export default function AccountDetails({
  open,
  close,
  profile,
  fullName,
  details,
  loading,
  error,
  retry,
}) {
  const groups = [
    [
      "Account information",
      [
        ["Full Name", fullName],
        ...details.map(([label, text]) => [label, text]),
        ["Account Status", flag(profile.status, "Active", "Inactive")],
        ["Account Blocked", flag(profile.isBlocked, "Yes", "No")],
      ],
    ],
    [
      "Account activity",
      [
        ["Created", timestamp(profile.createdOn)],
        ["Last Sign-in", timestamp(profile.lastLogin)],
        ["Last Updated", timestamp(profile.updatedOn)],
      ],
    ],
    ["Branch information", [["Branch Address", profile.branchDetail?.address]]],
    [
      "Firm information",
      [
        ["Firm Address", profile.firmDetail?.address],
        ["Firm Email", profile.firmDetail?.emailId],
        ["Firm Phone", profile.firmDetail?.contactNo],
        ["Website", profile.firmDetail?.website],
        ["Primary Contact", profile.firmDetail?.primaryContactName],
      ],
    ],
  ];
  return (
    <AppModal
      isOpen={open}
      toggle={close}
      scrollable
      style={{ width: "calc(100% - 32px)", maxWidth: "900px" }}
      labelledBy="account-details-title"
    >
      <ModalHeader id="account-details-title" toggle={close}>
        All Account Details
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <p role="status">Loading account details…</p>
        ) : error ? (
          <div role="alert">
            {error}{" "}
            <Button type="button" onClick={retry}>
              Retry
            </Button>
          </div>
        ) : (
          <>
            <p className="text-muted">
              Account information for {fullName}. Dates and times are shown in
              your local time zone.
            </p>
            {groups.map(([heading, fields]) => (
              <section
                key={heading}
                className="profile-account-details__section"
              >
                <h3>{heading}</h3>
                <dl className="profile-account-details__grid">
                  {fields.map(([label, text]) => (
                    <div key={label}>
                      <dt>{label}</dt>
                      <dd>{value(text)}</dd>
                    </div>
                  ))}
                </dl>
              </section>
            ))}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button type="button" onClick={close}>
          Close
        </Button>
      </ModalFooter>
    </AppModal>
  );
}
